import { useQuery } from '@tanstack/react-query'
import { defaultExchangeRateOptions } from './defaultExchangeRateOptions'
import { Currency } from '../../../types/currency/Currency'

export default function useDefaultExchangeRates(from?: Currency, to?: Currency) {
  const option = defaultExchangeRateOptions(from, to)
  return useQuery(option)
}
